import { render, staticRenderFns } from "./instockDetail.vue?vue&type=template&id=6a4c9e5f&scoped=true&"
import script from "./instockDetail.vue?vue&type=script&lang=js&"
export * from "./instockDetail.vue?vue&type=script&lang=js&"
import style0 from "./instockDetail.vue?vue&type=style&index=0&id=6a4c9e5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4c9e5f",
  null
  
)

export default component.exports